
import { Component, Mixins, Prop } from 'vue-property-decorator';
import DarkThemeInfoMixin from '~common-mixins/DarkThemeInfoMixin';
import UserRightsMixin from '~/mixins/UserRightsMixin';

@Component
export default class RemoteFeatureReleaseButtons extends Mixins(DarkThemeInfoMixin, UserRightsMixin) {
    @Prop() isReleased!: boolean;

    toggleReleaseValue() {
        if (!this.isDisabled && confirm('Are you sure you want to change the release status of this feature flag?')) {
            this.$emit('releaseFlag', !this.isReleased);
        }
    }

    get isDisabled() {
        return !this.isAllowed('RemoteFeatureFlagsNetatmo', 'release');
    }
}
